import SVGS from "../../core/assets/svg";
import ROUTE_CONSTANT from "../../routes/routeconstants";

const { ATS } = SVGS;

const ATSData = [
  {
    id: 1,
    label: "View Job",
    value: "View Job",
    to: ROUTE_CONSTANT.APPLICANT_JOB,
    // department: ["3", "7", "24"],
    Icon: ATS,
  },
  {
    id: 2,
    label: "Upload Docs",
    value: "Upload Docs",
    to: ROUTE_CONSTANT.UPLOAD_DOCUMNETS,
    Icon: ATS,
  },
  {
    id: 2,
    label: "Profile",
    value: "Profile",
    to: ROUTE_CONSTANT.APPLICANT_DETAILS_PRE,
    Icon: ATS,
  },
];
export default ATSData;
